<template>
    <div class="mt-5">
        <div>
            <h2 class="h4 font-weight-medium mb-3" style="calc(1.275rem + .3vw)">{{ title }}</h2>
        </div>
        <div>
            <div v-if="stores&&stores.length>0">
                <ui-data-table
                    :unSelectAllItemsDispatchName="unSelectAllItemsDispatchName"
                    :selectAllItemsDispatchName="selectAllItemsDispatchName"
                    :itemsGetterName="itemsGetterName"
                    :areAllItemsSelectedGetterName="areAllItemsSelectedGetterName"
                    :tableName="tableName"
                    @rowSelectChange="onRowSelectChange"
                    selectable
                    mobileBreakpoint="lg"
                    :tableData="tableData"
                />
            </div>
            <div v-else>
                Brak elementów do wyświetlenia.
            </div>
        </div>
    </div>
</template>

<script>
import { UiDataTable } from '../global/ui'

export default{
    components: { UiDataTable },
    props: {
        itemsGetterName: {
            type: String,
            default: ''
        },
        selectAllItemsDispatchName: {
            type: String,
            default: ''
        },
        unSelectAllItemsDispatchName: {
            type: String,
            default: ''
        },
        areAllItemsSelectedGetterName: {
            type: String,
            default: ''
        },
        tableName: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        tableData: {
            type: Object,
            default: () => { return { head: [], body: [] } }
        }

    },
    computed: {
        stores() {
            return this.$store.getters[this.itemsGetterName]
        }
    },
    methods: {
        onRowSelectChange(data) {
            this.$emit('rowSelectChange', data)
        }
    }
}
</script>